module.exports = __webpack_public_path__ + "media/images/sandbox/broschure_opt-b72e29903d66656f9a77aaee54affee9.png";